import { render, staticRenderFns } from "./registro.vue?vue&type=template&id=6c907519&scoped=true"
import script from "./registro.vue?vue&type=script&lang=js"
export * from "./registro.vue?vue&type=script&lang=js"
import style0 from "./registro.vue?vue&type=style&index=0&id=6c907519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c907519",
  null
  
)

export default component.exports